module.exports = __webpack_public_path__ + "6ef586428bfd6dcf9f44e1660a452e7a.svg";